import RequestBuilder from "okhttp/lib/builders/RequestBuilder";
import RequestBody from "okhttp/lib/RequestBody";
import MimeBuilder from "okhttp/lib/builders/MimeBuilder";

const API_URL = process.env.REACT_APP_API_URL

class KubernetesJobService {
    constructor(accessKey) {
        this.accessKey = accessKey;
    }
    async listCronJobs() {
        return new RequestBuilder()
            .header('Authorization', `Bearer ${this.accessKey}`)
            .header('Accept', 'application/json')
            .GET(`${API_URL}/cron-jobs`).buildAndExecute()
    }
    async generateJobFromCronJob(cronJobName) {
        return new RequestBuilder()
            .header('Authorization', `Bearer ${this.accessKey}`)
            .header('Accept', 'application/json')
            .GET(`${API_URL}/cron-jobs/${cronJobName}/generate-job`).buildAndExecute()
    }
    async runJob(jobJson) {
        return new RequestBuilder()
            .header('Authorization', `Bearer ${this.accessKey}`)
            .header('Content-Type', 'application/json')
            .url(`${API_URL}/jobs`)
            .POST(RequestBody.create(JSON.stringify(jobJson), new MimeBuilder().contentType('application/json', 'charset', 'utf8'))).buildAndExecute()
    }

    async manualRuns(cronJobName) {
        return new RequestBuilder()
            .header('Authorization', `Bearer ${this.accessKey}`)
            .header('Accept', 'application/json')
            .GET(`${API_URL}/cron-jobs/${cronJobName}/manual-runs`).buildAndExecute()
    }

    async jobStatus(jobName) {
        return new RequestBuilder()
            .header('Authorization', `Bearer ${this.accessKey}`)
            .header('Accept', 'application/json')
            .GET(`${API_URL}/jobs/${jobName}`).buildAndExecute()
    }
}

export default KubernetesJobService;
